const awsmobile = {
  aws_app_analytics: 'disable',
  aws_cognito_identity_pool_id: 'ap-northeast-1:a080cc42-b355-4391-911a-f8752c36986d',
  aws_cognito_region: 'ap-northeast-1',
  aws_mandatory_sign_in: 'enable',
  aws_sign_in_enabled: 'enable',
  aws_user_files: 'disable',
  aws_user_pools: 'enable',
  aws_user_pools_id: 'ap-northeast-1_0N3Ht6p4R',
  aws_user_pools_mfa_type: 'OFF',
  aws_user_pools_web_client_id: '12ulmshsqklbg71qi614tq0mn5'
};
export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js